import script from "./EvaluacionIndividualView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EvaluacionIndividualView.vue?vue&type=script&setup=true&lang=ts"

import "./EvaluacionIndividualView.vue?vue&type=style&index=0&id=4b72c484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b72c484"]])

export default __exports__